import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  RJSC_PAGE_LINK,
} from "../../app/constants";
import { fullName } from "../../app/utils";
import { push } from "connected-react-router";
import {
  Header,
  Button,
  Paragraph,
  NavigationLinkButton,
  ErrorMark,
} from "../../components/RegularComponents";
import {
  addNewAgentApplication,
  setCurrentAgentPersonDetails
} from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../app/errors";
import { setAgencyBusinessContact } from "../../redux/slice/primaryAgencyApplicationSlice";
import { mraPrincipalBrokerSelector } from "../../redux/selector/mraPrincipalBrokerSelector";

export const MraSelectPrincipalBroker = (props) => {
  // const applicationType = APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE;
  const applicationMode = APPLICATION_MODE_NEW;

  const { isModal = false, onEditSave = () => {} } = props;

  const [showError,setShowError] = useState(false)
  const [errorString, setErrorString] = useState(null)

  const companyRjscDetails = useSelector(
    (state) =>
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails
  );

  const {principalBrokerApplication} = useSelector(mraPrincipalBrokerSelector)

  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const principalBrokerSelect = useSelector((state) => ({
    primaryAgencyApplicationId: state.primaryAgencyApplication?.application?.id,
    companyRjscDetails:
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyRjscDetails,
    companyTrademark:
      state.primaryAgencyApplication?.application?.businessLicenceData
        ?.companyTrademark,
  }));

  const {
    primaryAgencyApplicationId,
    companyTrademark,
  } = principalBrokerSelect;

  const [selectedPrincipalBrokerEntityId, setSelectedPrincipalBrokerEntityId] =
    useState(null);

  const peopleList = companyRjscDetails?.businessData?.peopleList ?? []

  const nameListComponent = () => {
    const nameList = [];

    peopleList.forEach((people) => {
      const { entityId } = people;
      nameList.push(
        <div
          key={entityId}
          className="ns-radios__item"
          style={{ marginBottom: "1.5em" }}
        >
          <input
            className="ns-radios__input"
            key={entityId + "-input"}
            type={"radio"}
            value={entityId}
            checked={entityId === selectedPrincipalBrokerEntityId}
            onChange={(e) => setSelectedPrincipalBrokerEntityId(e.target.value)}
            id={"select-principal-broker-people-list-" + entityId + "-input"}
            name={"select-principal-broker-people-list-" + entityId + "-input"}
          />
          <label
            key={entityId + "-label"}
            id={"select-principal-broker-people-list-" + entityId + "-label"}
            className="ns-radios__label"
            htmlFor={
              "select-principal-broker-people-list-" + entityId + "-input"
            }
          >
            <span className="ns-label-span">
              {`${fullName(people)}, ${people.position}`}
            </span>
          </label>
        </div>
      );
    });

    return (
      <fieldset className="ns-fieldset">
        <div className={"ns-radios"}>{nameList}</div>
      </fieldset>
    );
  };

  const handleSave = () => {
    const selectedBrokers = peopleList.filter(
      (p) => p.entityId === selectedPrincipalBrokerEntityId
    );

    if (!selectedBrokers?.length) {
      setShowError(true)
      setErrorString(ERROR_STRING.SELECT_AT_LEAST_ONE_OFFICER)
      return false
    }

    setShowError(false)
    setErrorString(null)

    const principalBroker = selectedBrokers[0];

    // TODO : make sure there is no principal broker application already present before adding
    if(!principalBrokerApplication) { 
      dispatch(
        addNewAgentApplication({
          agentLicenceSubType : LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
          businessApplicationId: primaryAgencyApplicationId,
          businessName: companyRjscDetails.businessEntity.businessName,
          companyRjscDetails,
          companyTrademark: companyTrademark ? companyTrademark : null,
        })
      );
    }

    // dispatch(setCurrentAgentAsPrincipalBroker())

    dispatch(
      setCurrentAgentPersonDetails({
        firstName: principalBroker.firstName,
        lastName: principalBroker.lastName,
        rjscEntityId: principalBroker.entityId,
      })
    );

    dispatch(
      setAgencyBusinessContact({
        mainBusinessContact: {
          firstName: principalBroker.firstName,
          lastName: principalBroker.lastName,
        }
      })
    )

    return true
  }

  const handleSaveNext = () => {
    
    if (handleSave()) {
      const p1 = dispatch(saveBusinessLicenceApplicationData(
        APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE, applicationMode))
      const p2 = dispatch(saveBusinessLicenceApplicationData(
        APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, applicationMode))
  
      Promise.all([p1,p2]).then(values => {
          // application saved, go to the next page.
          dispatch(
            push(
              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER}`
            )
          );
        })
        .catch(error => {
          setApplicationSaveError(true);
        });
    }
  };

  const handleSaveandClose = () => {
    if (handleSave()) {
      onEditSave();
    }
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <div className="row">
              <div className="col-lg-8">
                <Header
                  id="select-principal-broker-header"
                  header="Principal broker"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-8">
            <Paragraph
              id="select-principal-broker-text"
              text={["Select your name from the list"]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">{nameListComponent()}</div>
        </div>

        <div className="row">
          <div
            className={"col-lg-2" + ((applicationSaveError || showError) ? " has-error" : "")}
          >
            <Button
              id="select-principal-broker-save-next-button"
              buttonType="regular_primary"
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleSaveNext : handleSaveandClose}
            />
            {(applicationSaveError || showError) && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
            {showError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {errorString}
              </div>
            )}
          </div>
          <div className="col-lg-4">
            <NavigationLinkButton
              id="select-pricipal-broker-no-name-button"
              text="My name isn't on this list"
              onClick={() => {
                window.location.assign(RJSC_PAGE_LINK)
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
